<template>
    <div class="noticias" v-if="noticias.length > 0">
        <div class="row">
            <span class="txt-p txt-roxo-1 txt-size-25 txt-w-5">Notícias</span>
            <div class="col-5 col-md-5 d-flex flex-column justify-content-between">
                <div>

                    <p class="txt-p txt-cores-2 recuo">
                        Todo dia útil a página é atualizada com as últimas notícias, com um conteúdo exclusivo na capa, com artigos de especialistas, e vídeos novos. Conteúdo de interesse e relevância para as pessoas que pensam em licitações e contratos públicos, que se preocupam em fazer certo e melhor. O Sollicita dá a você todo conteúdo de licitação que você precisa – quando você precisa.
                    </p>
                </div>
                <div>
                    <a class="btn btn-roxo txt-size-14 px-2" :href="urlSollicita" target="_blank">ACESSE O PORTAL DE NOTÍCIAS</a>
                </div>
            </div>
            <div class="col-7 col-md-7">
                <div class="row">
                    <div class="col-12 col-md-6 mb-3 mb-md-0" v-for="item in noticias" :key="item.idNoticia">
                        <a class="" :href="item.urlNoticia" target="_blank">
                            <div class="box-noticia txt-cores-2">
                                <img class="w-100" :src="item.urlImagem" />
                                <div class="d-flex justify-content-end my-3">
                                    <span class="txt-l txt-w-bold ">{{formatDate(item.dtPublicacao)}}</span>
                                </div>
                                <p class="txt-p txt-w-bold txt-size-20 mb-2">{{item.dsTitulo}}</p>
                                <p class="txt-p txt-size-16">{{item.dsDescricao}}</p>
                            </div>
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, urlSollicita } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    import primeira from '@/assets/img/noticia-1.jpg'
    import segunda from '@/assets/img/noticia-2.jpg'

    export default {
        name: 'Noticias',
        data: function () {
            return {
                urlSollicita: urlSollicita,
                primeira,
                segunda,
                noticias: [],
            }
        },
        methods: {
            load() {
                this.carregaNoticias();
            },

            carregaNoticias() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/Get`, { params: { take: 2, index: 0, isNoticiaPrincipal: true, flGetImagemS3: true } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let noticia = res.data.data.rows[i];
                                    noticia.urlNoticia = $this.getUrlNoticia(noticia.idNoticia, noticia.dsTitulo);
                                    $this.noticias.push(noticia);
                                }

                            }
                        } else {
                            avisoErro("Não foi possível carregar as notícias");
                            this.noticias = [
                                { idNoticia: 1, urlImagem: primeira, dtPublicacao: '2021-07-07 07:00:00', dsTitulo: 'Sustentabilidade nas licitações e a economicidade - Parte 4', dsDescricao: 'Desafio para o desenvolvimento Nacional Sustentável', },
                                { idNoticia: 2, urlImagem: segunda, dtPublicacao: '2021-07-07 07:00:00', dsTitulo: 'Sustentabilidade nas licitações e a economicidade - Parte 4', dsDescricao: 'Desafio para o desenvolvimento Nacional Sustentável', },
                            ];
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar as notícias");
                        this.noticias = [
                            { idNoticia: 1, urlImagem: primeira, dtPublicacao: '2021-07-07 07:00:00', dsTitulo: 'Sustentabilidade nas licitações e a economicidade - Parte 4', dsDescricao: 'Desafio para o desenvolvimento Nacional Sustentável', },
                            { idNoticia: 2, urlImagem: segunda, dtPublicacao: '2021-07-07 07:00:00', dsTitulo: 'Sustentabilidade nas licitações e a economicidade - Parte 4', dsDescricao: 'Desafio para o desenvolvimento Nacional Sustentável', },
                        ];
                    });
            },

            getUrlNoticia(idNoticia, titulo) {
                return urlSollicita + 'Noticia/?p_idNoticia=' + idNoticia + '&n=' + titulo.toLowerCase().replace(/\s/g, '-');
            },

            formatDate(date) {
                if (date) {
                    return moment(date).format('DD/MM/YYYY [às] HH:mm');
                } else {
                    return "";
                }
            },
        },
        created: function () {
            this.load();
        }

    };
</script>

<style scoped>
    .box-noticia {
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(122, 122, 122, 0.25);
        border-radius: 5px;
        padding: 30px;
    }
</style>